<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button  (click)="closePopUpOfQuote()" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-md-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="row">
          <div class="col-md-6">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown class="w-100" [options]="realEstateStatus" formControlName="realEstateStatus" optionLabel="name"
              optionValue="value" placeholder="Status" [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
              <label for="Status">Status</label>
              @for (validation of validationMessages.realEstateStatus; track validation) {
                <span>
                  @if (form1.get('realEstateStatus').hasError(validation.type) && (form1.get('realEstateStatus').dirty || form1.get('realEstateStatus').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-md-3 d-flex justify-content-end">
            <label>Owner Portal: Show Future Reservation Income : </label>&nbsp;&nbsp;
            <p-inputSwitch (onChange)="updateShowResIncomeFlag()" formControlName="showRezIncome">
            </p-inputSwitch>
            @for (validation of validationMessages.showRezIncome; track validation) {
              <span>
                @if (form1.get('showRezIncome').hasError(validation.type) && (form1.get('showRezIncome').dirty || form1.get('showRezIncome').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
          <!-- <div class="col-md-1">
          <span class="p-float-label required-field w-100 mb-3"> -->

          <!-- </span>
        </div> -->
        <div class="col-md-3 d-flex justify-content-end">
          <label>Owner Portal: Show Online Statements : </label>&nbsp;&nbsp;
          <p-inputSwitch (onChange)="updateShowResIncomeFlag()" formControlName="viewOnlineStmt">
          </p-inputSwitch>
          @for (validation of validationMessages.viewOnlineStmt; track validation) {
            <span>
              @if (form1.get('viewOnlineStmt').hasError(validation.type) && (form1.get('viewOnlineStmt').dirty || form1.get('viewOnlineStmt').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div class="col-md-6">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="1" pInputTextarea></textarea>
            <label for="opsNotes">Ops Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-md-3 d-flex justify-content-end">
          <label>Owner Portal: Show Past Reservation Income : </label>&nbsp;&nbsp;
          <p-inputSwitch (onChange)="updateShowResIncomeFlag()" formControlName="showPastReservationIncome">
          </p-inputSwitch>
          @for (validation of validationMessages.showPastReservationIncome; track validation) {
            <span>
              @if (form1.get('showPastReservationIncome').hasError(validation.type) && (form1.get('showPastReservationIncome').dirty || form1.get('showPastReservationIncome').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div class="col-md-3 d-flex justify-content-end">
          <label>Owner Portal: Show Past Occupancy Calander : </label>&nbsp;&nbsp;
          <p-inputSwitch (onChange)="updateShowResIncomeFlag()" formControlName="showPastOccupancyCalander">
          </p-inputSwitch>
          @for (validation of validationMessages.showPastOccupancyCalander; track validation) {
            <span>
              @if (form1.get('showPastOccupancyCalander').hasError(validation.type) && (form1.get('showPastOccupancyCalander').dirty || form1.get('showPastOccupancyCalander').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>



        <!-- <div class="col-md-3 d-flex justify-content-end">
        <label>GIG : </label>
      </div>
      <div class="col-md-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputSwitch (onChange)="formUpdate()" formControlName="gig">
          </p-inputSwitch>
          <span *ngFor="let validation of validationMessages.gig">
            <small class="p-invalid"
              *ngIf="form1.get('gig').hasError(validation.type) && (form1.get('gig').dirty || form1.get('gig').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->
      <!-- <div *ngIf="isDisplayOwnerProfile" class="row d-flex"> -->
      @if (propertyProfile?.propertyProfileId != undefined) {
        <div class="col-md-5">
          <span class="p-float-label required-field w-100 mb-4">
            <p-multiSelect [options]="ownerProfilesList" formControlName="ownerProfileVOList" appendTo="body"
              defaultLabel="Select Owner Profiles" optionLabel="displayLabel"
            (onChange)="updateOwnerProfileOfPropertyProfile()" [dropdownIcon]="'fa fa-caret-down'"></p-multiSelect>
            <label for="Select Owner Profiles">Select Owner Profiles</label>
            @for (validation of validationMessages.ownerProfileVOList; track validation) {
              <span>
                @if (form1.get('ownerProfileVOList').hasError(validation.type) && (form1.get('ownerProfileVOList').dirty || form1.get('ownerProfileVOList').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      }

      <!-- <div class="col-12 row py-0 px-0"> -->
      @if (propertyProfile?.propertyProfileId == undefined) {
        <div class="col-md-5">
          <span class="p-float-label required-field w-100 mb-4">
            <p-multiSelect class="lead-select" [options]="ownerProfilesList" formControlName="ownerProfileVOList"
            appendTo="body" defaultLabel="Select Owner Profiles" optionLabel="displayLabel"></p-multiSelect>
            <label for="Select Owner Profiles">Select Owner Profiles</label>
            @for (validation of validationMessages.ownerProfileVOList; track validation) {
              <span>
                @if (form1.get('ownerProfileVOList').hasError(validation.type) && (form1.get('ownerProfileVOList').dirty || form1.get('ownerProfileVOList').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      }

      <div class="col-1 py-0 d-flex justify-content-start align-items-center">
        <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddOwnerProfile()">
          <i class="pi pi-plus"></i>
        </button>
      </div>
      <div class="col-md-3 d-flex justify-content-end">
        <label>Owner Portal: Show Maintenance Tab : </label>&nbsp;&nbsp;
        <p-inputSwitch (onChange)="updateShowResIncomeFlag()" formControlName="showMaintenanceTab">
        </p-inputSwitch>
        @for (validation of validationMessages.showMaintenanceTab; track validation) {
          <span>
            @if (form1.get('showMaintenanceTab').hasError(validation.type) && (form1.get('showMaintenanceTab').dirty || form1.get('showMaintenanceTab').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </div>
    <!-- </div> -->

    <!-- <div *ngIf="propertyProfile?.propertyProfileId == undefined" class="col-5 row py-0">
    <div class="col-md-5">
      <span class="p-float-label required-field w-100 mb-4">
        <p-multiSelect [options]="ownerProfilesList" formControlName="ownerProfileVOList"
          appendTo="body" defaultLabel="Select Owner Profiles">

          <ng-template let-item pTemplate="item">
            {{item.lastName}}, {{item.firstName}}
          </ng-template>

          <ng-template let-item pTemplate="selectedItem">
            {{item.lastName}}, {{item.firstName}}
          </ng-template>
        </p-multiSelect>
        <label for="Select Owner Profiles">Select Owner Profiles</label>
        <span *ngFor="let validation of validationMessages.ownerProfileVOList">
          <small class="p-invalid"
            *ngIf="form1.get('ownerProfileVOList').hasError(validation.type) && (form1.get('ownerProfileVOList').dirty || form1.get('ownerProfileVOList').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>
  </div> -->
  <!-- <div *ngIf="propertyProfile?.propertyProfileId == undefined" class="col-md-6"></div>
  <div *ngIf="propertyProfile?.propertyProfileId != undefined" class="col-md-6"></div> -->
  @if (propertyProfile?.propertyProfileId != undefined) {
    <div class="col-md-6">
      <span class="p-float-label required-field w-100 mb-3">
        <p-table [value]="propertyProfile?.ownerProfileVOList" [tableStyle]="{ 'min-width': 'auto' }">
          <ng-template pTemplate="header">
            <tr>
              <th [ngStyle]="{'width': 'auto'}">First Name</th>
              <th [ngStyle]="{'width': 'auto'}">Last Name</th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-ownerProfile>
            <tr>
              <td>
                {{ ownerProfile.firstName }}
              </td>
              <td>
                {{ ownerProfile.lastName }}
              </td>
              <td>
                <span style="float:none">
                  <a>
                    <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%;"
                    (click)="fetchOwnerProfileById(ownerProfile)"></i>
                  </a>
                </span>
              </td>
              <td>
                <span style="float:none">
                  <a>
                    <i class="pi pi-trash" aria-hidden="true"
                      style="color:red; font-size:110%; padding-right:5px;"
                    (click)="onFormDeleteOfOwnerProfile(ownerProfile)"></i>
                  </a>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </span>
    </div>
  }
<!-- </div> -->


<div class="col-md-6">
  <span class="p-float-label required-field w-100 mb-3">
    <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
      optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
      placeholder="Select Short Term Rental" [dropdownIcon]="'fa fa-caret-down'" appendTo="body">
    </p-dropdown>
    <label for="Select Short Term Rental">Select Short Term Rental</label>
    @for (validation of validationMessages.shortTermRentalId; track validation) {
      <span>
        @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>
<div class="col-md-6"></div>
<div class="col-md-6">
  <span class="p-float-label fullwidthinput required-field w-100 mb-3">
    <p-autoComplete #locationSearch class="error-bg" appendTo="body" placeholder=""
      formControlName="propertyLeadProfileId" [suggestions]="filteredNames"
      (completeMethod)="changeNameFilter($event.query)" field="summary" [minLength]="1" forceSelection=true>

      <ng-template let-filteredNames pTemplate="item">
        <div class="country-item">
          <div class="title">
            {{filteredNames.subjAdrStreet}} {{filteredNames.subjAdrDevelopmentName}}
            {{filteredNames.firstName}} {{filteredNames.lastName}}
          {{filteredNames.propertyLeadProfileId}} </div>
        </div>
      </ng-template>
    </p-autoComplete>
    <label for="Search Property Lead Profiles By DevelopmentName, Street, firstName, lastName">Search
    Property Lead Profiles By DevelopmentName, Street, firstName, lastName</label>
  </span>
</div>
<div class="col-md-6"></div>
<div class="col-md-6">
  <span class="p-float-label w-100 mb-3">
    <input formControlName="propertyName" id="propertyName" type="text" pInputText>
    <label for="propertyName">Property Name</label>
    @for (validation of validationMessages.propertyName; track validation) {
      <span>
        @if (form1.get('propertyName').hasError(validation.type) && (form1.get('propertyName').dirty || form1.get('propertyName').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>
</div>

<div class="row">
  <div class="col-md-6">
    <div>
      <div class="mb-3 fw-bold title">Tax Details</div>
      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="fedTaxName" id="fedTaxName" type="text" pInputText>
            <label for="fedTaxName">Fed Tax Name</label>
            @for (validation of validationMessages.fedTaxName; track validation) {
              <span>
                @if (form1.get('fedTaxName').hasError(validation.type) && (form1.get('fedTaxName').dirty || form1.get('fedTaxName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="fedTaxBusName" id="fedTaxBusName" type="text" pInputText>
            <label for="fedTaxBusName">Fed Tax Bus Name</label>
            @for (validation of validationMessages.fedTaxBusName; track validation) {
              <span>
                @if (form1.get('fedTaxBusName').hasError(validation.type) && (form1.get('fedTaxBusName').dirty || form1.get('fedTaxBusName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="fedTaxClass" id="fedTaxClass" type="text" pInputText>
            <label for="fedTaxClass">Fed Tax Class</label>
            @for (validation of validationMessages.fedTaxClass; track validation) {
              <span>
                @if (form1.get('fedTaxClass').hasError(validation.type) && (form1.get('fedTaxClass').dirty || form1.get('fedTaxClass').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">


        <div class="col-md-4">
          <span class="p-float-label  w-100 mb-3">
            <input formControlName="fedTaxId" id="fedTaxId" type="text" pInputText>
            <label for="fedTaxId">Fed Tax Id</label>
            @for (validation of validationMessages.fedTaxId; track validation) {
              <span>
                @if (form1.get('fedTaxId').hasError(validation.type) && (form1.get('fedTaxId').dirty || form1.get('fedTaxId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="fedTaxAddress" id="fedTaxAddress" type="text" pInputText>
            <label for="fedTaxAddress">Fed Tax Address</label>
            @for (validation of validationMessages.fedTaxAddress; track validation) {
              <span>
                @if (form1.get('fedTaxAddress').hasError(validation.type) && (form1.get('fedTaxAddress').dirty || form1.get('fedTaxAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="taxPreparationSource" id="taxPreparationSource" type="text" pInputText>
            <label for="taxPreparationSource">Tax Preparation Source</label>
            @for (validation of validationMessages.taxPreparationSource; track validation) {
              <span>
                @if (form1.get('taxPreparationSource').hasError(validation.type) && (form1.get('taxPreparationSource').dirty || form1.get('taxPreparationSource').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>

    <div>
      <div class="mb-3 fw-bold title">Alert Preferences</div>
      <div class="row">
        <div class="col-md-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="deepCleanPrepDays" id="deepCleanPrepDays" type="number" pInputText>
            <label for="deepCleanPrepDays">Homeowner Arrival Prep Days</label>
            @for (validation of validationMessages.deepCleanPrepDays; track validation) {
              <span>
                @if (form1.get('deepCleanPrepDays').hasError(validation.type) && (form1.get('deepCleanPrepDays').dirty || form1.get('deepCleanPrepDays').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-md-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="newReservationAlertEmail" id="newReservationAlertEmail" type="text" pInputText>
            <label for="newReservationAlertEmail">New Reservation Alert Email</label>
            @for (validation of validationMessages.newReservationAlertEmail; track validation) {
              <span>
                @if (form1.get('newReservationAlertEmail').hasError(validation.type) && (form1.get('newReservationAlertEmail').dirty || form1.get('newReservationAlertEmail').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="newReservationAlertText" id="newReservationAlertText" type="text" pInputText>
            <label for="newReservationAlertText">New Reservation Alert Text</label>
            @for (validation of validationMessages.newReservationAlertText; track validation) {
              <span>
                @if (form1.get('newReservationAlertText').hasError(validation.type) && (form1.get('newReservationAlertText').dirty || form1.get('newReservationAlertText').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>

    <div>
      <div class="mb-3 fw-bold title">Insurance</div>
      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="insCompanyName" id="insCompanyName" type="text" pInputText>
            <label for="insCompanyName">Company Name</label>
            @for (validation of validationMessages.insCompanyName; track validation) {
              <span>
                @if (form1.get('insCompanyName').hasError(validation.type) && (form1.get('insCompanyName').dirty || form1.get('insCompanyName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="insPolicyNum" id="insPolicyNum" type="text" pInputText>
            <label for="insPolicyNum">Policy Num</label>
            @for (validation of validationMessages.insPolicyNum; track validation) {
              <span>
                @if (form1.get('insPolicyNum').hasError(validation.type) && (form1.get('insPolicyNum').dirty || form1.get('insPolicyNum').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="insAgentName" id="insAgentName" type="text" pInputText>
            <label for="insAgentName">Agent Name</label>
            @for (validation of validationMessages.insAgentName; track validation) {
              <span>
                @if (form1.get('insAgentName').hasError(validation.type) && (form1.get('insAgentName').dirty || form1.get('insAgentName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="insAgentEmail" id="insAgentEmail" type="text" pInputText>
            <label for="insAgentEmail">Agent Email</label>
            @for (validation of validationMessages.insAgentEmail; track validation) {
              <span>
                @if (form1.get('insAgentEmail').hasError(validation.type) && (form1.get('insAgentEmail').dirty || form1.get('insAgentEmail').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="insAgentPhone" id="insAgentPhone" type="text" pInputText>
            <label for="insAgentPhone">Agent Phone</label>
            @for (validation of validationMessages.insAgentPhone; track validation) {
              <span>
                @if (form1.get('insAgentPhone').hasError(validation.type) && (form1.get('insAgentPhone').dirty || form1.get('insAgentPhone').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>

    <div>
      <div class="mb-3 fw-bold title">Banking</div>
      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="bankName" id="bankName" type="text" pInputText>
            <label for="bankName">Name</label>
            @for (validation of validationMessages.bankName; track validation) {
              <span>
                @if (form1.get('bankName').hasError(validation.type) && (form1.get('bankName').dirty || form1.get('bankName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="bankRoutingNum" id="bankRoutingNum" type="text" pInputText>
            <label for="bankRoutingNum">Routing Num</label>
            @for (validation of validationMessages.bankRoutingNum; track validation) {
              <span>
                @if (form1.get('bankRoutingNum').hasError(validation.type) && (form1.get('bankRoutingNum').dirty || form1.get('bankRoutingNum').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="bankAccountNum" id="bankAccountNum" type="text" pInputText>
            <label for="bankAccountNum">Account Num</label>
            @for (validation of validationMessages.bankAccountNum; track validation) {
              <span>
                @if (form1.get('bankAccountNum').hasError(validation.type) && (form1.get('bankAccountNum').dirty || form1.get('bankAccountNum').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>

    <div>
      <div class="mb-3 fw-bold title">Tax Filing</div>
      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="taxPaidOptions" formControlName="taxPaidBy" optionLabel="name"
            optionValue="value" placeholder="Tax Paid By" [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
            <label for="taxPaidBy">Tax Paid By</label>
            @for (validation of validationMessages.taxPaidBy; track validation) {
              <span>
                @if (form1.get('taxPaidBy').hasError(validation.type) && (form1.get('taxPaidBy').dirty || form1.get('taxPaidBy').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="taxDeptUsername" id="taxDeptUsername" type="text" pInputText>
            <label for="taxDeptUsername">Dept Username</label>
            @for (validation of validationMessages.taxDeptUsername; track validation) {
              <span>
                @if (form1.get('taxDeptUsername').hasError(validation.type) && (form1.get('taxDeptUsername').dirty || form1.get('taxDeptUsername').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="taxDeptPassword" id="taxDeptPassword" type="text" pInputText>
            <label for="taxDeptPassword">Dept Password</label>
            @for (validation of validationMessages.taxDeptPassword; track validation) {
              <span>
                @if (form1.get('taxDeptPassword').hasError(validation.type) && (form1.get('taxDeptPassword').dirty || form1.get('taxDeptPassword').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="taxDeptNotes" id="taxDeptNotes" [rows]="2" pInputTextarea></textarea>
            <label for="taxDeptNotes">Dept Notes</label>
            @for (validation of validationMessages.taxDeptNotes; track validation) {
              <span>
                @if (form1.get('taxDeptNotes').hasError(validation.type) && (form1.get('taxDeptNotes').dirty || form1.get('taxDeptNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>

    <div>
      <div class="mb-3 fw-bold title">Subject Address</div>

      <div class="row">
        <div class="col-md-12">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrCompanyName" id="subjAdrCompanyName" type="text" pInputText>
            <label for="subjAdrCompanyName">Company Name</label>
            @for (validation of validationMessages.subjAdrCompanyName; track validation) {
              <span>
                @if (form1.get('subjAdrCompanyName').hasError(validation.type) && (form1.get('subjAdrCompanyName').dirty || form1.get('subjAdrCompanyName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrStreet" id="subjAdrStreet" type="text" pInputText>
            <label for="subjAdrStreet">Street</label>
            @for (validation of validationMessages.subjAdrStreet; track validation) {
              <span>
                @if (form1.get('subjAdrStreet').hasError(validation.type) && (form1.get('subjAdrStreet').dirty || form1.get('subjAdrStreet').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrStreet2" id="subjAdrStreet2" type="text" pInputText>
            <label for="subjAdrStreet2">Street2</label>
            @for (validation of validationMessages.subjAdrStreet2; track validation) {
              <span>
                @if (form1.get('subjAdrStreet2').hasError(validation.type) && (form1.get('subjAdrStreet2').dirty || form1.get('subjAdrStreet2').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrCity" id="subjAdrCity" type="text" pInputText>
            <label for="subjAdrCity">City</label>
            @for (validation of validationMessages.subjAdrCity; track validation) {
              <span>
                @if (form1.get('subjAdrCity').hasError(validation.type) && (form1.get('subjAdrCity').dirty || form1.get('subjAdrCity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown [options]="states" formControlName="subjAdrState" optionLabel="name" appendTo="body"
              optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false" placeholder="State"
              [dropdownIcon]="'fa fa-caret-down'">
            </p-dropdown>
            <label for="State">State</label>
            @for (validation of validationMessages.subjAdrState; track validation) {
              <span>
                @if (form1.get('subjAdrState').hasError(validation.type) && (form1.get('subjAdrState').dirty || form1.get('subjAdrState').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="subjAdrPostalCode" id="subjAdrPostalCode" type="text" pInputText>
            <label for="subjAdrPostalCode">Postal Code</label>
            @for (validation of validationMessages.subjAdrPostalCode; track validation) {
              <span>
                @if (form1.get('subjAdrPostalCode').hasError(validation.type) && (form1.get('subjAdrPostalCode').dirty || form1.get('subjAdrPostalCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown [options]="countries" formControlName="subjAdrCountry" optionLabel="name" appendTo="body"
              optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false" placeholder="Country"
              [dropdownIcon]="'fa fa-caret-down'">
            </p-dropdown>
            <label for="Sub Address Country">Country</label>
            @for (validation of validationMessages.subjAdrCountry; track validation) {
              <span>
                @if (form1.get('subjAdrCountry').hasError(validation.type) && (form1.get('subjAdrCountry').dirty || form1.get('subjAdrCountry').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-md-4">
          <span class="p-float-label w-100 mb-3">
            <!-- <p-inputMask formControlName="subjAdrPhone" id="subjAdrPhone" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="subjAdrPhone" id="subjAdrPhone" type="text" pInputText>
          <label for="subjAdrPhone">Phone</label>
          @for (validation of validationMessages.subjAdrPhone; track validation) {
            <span>
              @if (form1.get('subjAdrPhone').hasError(validation.type) && (form1.get('subjAdrPhone').dirty || form1.get('subjAdrPhone').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrFax" id="subjAdrFax" type="text" pInputText>
          <label for="subjAdrFax">Fax</label>
          @for (validation of validationMessages.subjAdrFax; track validation) {
            <span>
              @if (form1.get('subjAdrFax').hasError(validation.type) && (form1.get('subjAdrFax').dirty || form1.get('subjAdrFax').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrUnit" id="subjAdrUnit" type="text" pInputText>
          <label for="subjAdrUnit">Unit</label>
          @for (validation of validationMessages.subjAdrUnit; track validation) {
            <span>
              @if (form1.get('subjAdrUnit').hasError(validation.type) && (form1.get('subjAdrUnit').dirty || form1.get('subjAdrUnit').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrDevelopmentName" id="subjAdrDevelopmentName" type="text" pInputText>
          <label for="subjAdrDevelopmentName">Dev Name</label>
          @for (validation of validationMessages.subjAdrDevelopmentName; track validation) {
            <span>
              @if (form1.get('subjAdrDevelopmentName').hasError(validation.type) && (form1.get('subjAdrDevelopmentName').dirty || form1.get('subjAdrDevelopmentName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrDistrictName" id="subjAdrDistrictName" type="text" pInputText>
          <label for="subjAdrDistrictName">District Name</label>
          @for (validation of validationMessages.subjAdrDistrictName; track validation) {
            <span>
              @if (form1.get('subjAdrDistrictName').hasError(validation.type) && (form1.get('subjAdrDistrictName').dirty || form1.get('subjAdrDistrictName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrCounty" id="subjAdrCounty" type="text" pInputText>
          <label for="subjAdrCounty">Country</label>
          @for (validation of validationMessages.subjAdrCounty; track validation) {
            <span>
              @if (form1.get('subjAdrCounty').hasError(validation.type) && (form1.get('subjAdrCounty').dirty || form1.get('subjAdrCounty').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrRegion" id="subjAdrRegion" type="text" pInputText>
          <label for="subjAdrRegion">Region</label>
          @for (validation of validationMessages.subjAdrRegion; track validation) {
            <span>
              @if (form1.get('subjAdrRegion').hasError(validation.type) && (form1.get('subjAdrRegion').dirty || form1.get('subjAdrRegion').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrIsland" id="subjAdrIsland" type="text" pInputText>
          <label for="subjAdrIsland">Island</label>
          @for (validation of validationMessages.subjAdrIsland; track validation) {
            <span>
              @if (form1.get('subjAdrIsland').hasError(validation.type) && (form1.get('subjAdrIsland').dirty || form1.get('subjAdrIsland').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrCrossStreet" id="subjAdrCrossStreet" type="text" pInputText>
          <label for="subjAdrCrossStreet">Cross Street</label>
          @for (validation of validationMessages.subjAdrCrossStreet; track validation) {
            <span>
              @if (form1.get('subjAdrCrossStreet').hasError(validation.type) && (form1.get('subjAdrCrossStreet').dirty || form1.get('subjAdrCrossStreet').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrLongitude" id="subjAdrLongitude" type="text" pInputText>
          <label for="subjAdrLongitude">Longitude</label>
          @for (validation of validationMessages.subjAdrLongitude; track validation) {
            <span>
              @if (form1.get('subjAdrLongitude').hasError(validation.type) && (form1.get('subjAdrLongitude').dirty || form1.get('subjAdrLongitude').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrLatitude" id="subjAdrLatitude" type="text" pInputText>
          <label for="subjAdrLatitude">Latitude</label>
          @for (validation of validationMessages.subjAdrLatitude; track validation) {
            <span>
              @if (form1.get('subjAdrLatitude').hasError(validation.type) && (form1.get('subjAdrLatitude').dirty || form1.get('subjAdrLatitude').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">

      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrBuildingName" id="subjAdrBuildingName" type="text" pInputText>
          <label for="subjAdrBuildingName">Building Name</label>
          @for (validation of validationMessages.subjAdrBuildingName; track validation) {
            <span>
              @if (form1.get('subjAdrBuildingName').hasError(validation.type) && (form1.get('subjAdrBuildingName').dirty || form1.get('subjAdrBuildingName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrComplexName" id="subjAdrComplexName" type="text" pInputText>
          <label for="subjAdrComplexName">Complex Name</label>
          @for (validation of validationMessages.subjAdrComplexName; track validation) {
            <span>
              @if (form1.get('subjAdrComplexName').hasError(validation.type) && (form1.get('subjAdrComplexName').dirty || form1.get('subjAdrComplexName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="subjAdrStreetNumber" id="subjAdrStreetNumber" type="text" pInputText>
          <label for="subjAdrStreetNumber">Street Number</label>
          @for (validation of validationMessages.subjAdrStreetNumber; track validation) {
            <span>
              @if (form1.get('subjAdrStreetNumber').hasError(validation.type) && (form1.get('subjAdrStreetNumber').dirty || form1.get('subjAdrStreetNumber').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="photographerDesc" id="photographerDesc" [rows]="2" pInputTextarea></textarea>
          <label for="photographerDesc">Photographer Description</label>
          @for (validation of validationMessages.photographerDesc; track validation) {
            <span>
              @if (form1.get('photographerDesc').hasError(validation.type) && (form1.get('photographerDesc').dirty || form1.get('photographerDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
  </div>

  <div>
    <div class="mb-3 fw-bold title">Onboarding</div>
    <div class="row">
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="trnsInEffectiveDate" inputId="trnsInEffectiveDate" appendTo="body">
          </p-calendar>
          <label for="trnsInEffectiveDate">Trns In Effective Date</label>
          @for (validation of validationMessages.trnsInEffectiveDate; track validation) {
            <span>
              @if (form1.get('trnsInEffectiveDate').hasError(validation.type) && (form1.get('trnsInEffectiveDate').dirty || form1.get('trnsInEffectiveDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown class="w-100" [options]="trnsReasons" formControlName="trnsInReason" optionLabel="name"
          optionValue="value" placeholder="Trns In Reason" [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
          <label for="trnsInReason">Trns In Reason</label>
          @for (validation of validationMessages.trnsInReason; track validation) {
            <span>
              @if (form1.get('trnsInReason').hasError(validation.type) && (form1.get('trnsInReason').dirty || form1.get('trnsInReason').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="trnsInNewMgrName" id="trnsInNewMgrName" type="text" pInputText>
          <label for="trnsInNewMgrName">Trns In New Mgr Name</label>
          @for (validation of validationMessages.trnsInNewMgrName; track validation) {
            <span>
              @if (form1.get('trnsInNewMgrName').hasError(validation.type) && (form1.get('trnsInNewMgrName').dirty || form1.get('trnsInNewMgrName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="trnsInProcessDesc" id="trnsInProcessDesc" [rows]="2"
          pInputTextarea></textarea>
          <label for="trnsInProcessDesc">Trns In Process Desc</label>
          @for (validation of validationMessages.trnsInProcessDesc; track validation) {
            <span>
              @if (form1.get('trnsInProcessDesc').hasError(validation.type) && (form1.get('trnsInProcessDesc').dirty || form1.get('trnsInProcessDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="trnsInHonoredBookingsDesc" id="trnsInHonoredBookingsDesc" [rows]="2"
          pInputTextarea></textarea>
          <label for="trnsInHonoredBookingsDesc">Trns In Honored Bookings Desc</label>
          @for (validation of validationMessages.trnsInHonoredBookingsDesc; track validation) {
            <span>
              @if (form1.get('trnsInHonoredBookingsDesc').hasError(validation.type) && (form1.get('trnsInHonoredBookingsDesc').dirty || form1.get('trnsInHonoredBookingsDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="trnsInReasonDesc" id="trnsInReasonDesc" [rows]="2" pInputTextarea></textarea>
          <label for="trnsInReasonDesc">Trns In Reason Description</label>
          @for (validation of validationMessages.trnsInReasonDesc; track validation) {
            <span>
              @if (form1.get('trnsInReasonDesc').hasError(validation.type) && (form1.get('trnsInReasonDesc').dirty || form1.get('trnsInReasonDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
  </div>



  <div>
    <div class="title mb-3 fw-bold">Offboarding</div>

    <div class="row">
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="trnsOutNoticeDate" inputId="trnsOutNoticeDate" appendTo="body">
          </p-calendar>
          <label for="trnsOutNoticeDate">Trns Out Notice Date</label>
          @for (validation of validationMessages.trnsOutNoticeDate; track validation) {
            <span>
              @if (form1.get('trnsOutNoticeDate').hasError(validation.type) && (form1.get('trnsOutNoticeDate').dirty || form1.get('trnsOutNoticeDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="trnsOutEffectiveDate" inputId="trnsOutEffectiveDate" appendTo="body">
          </p-calendar>
          <label for="trnsOutEffectiveDate">Trns Out Effective Date</label>
          @for (validation of validationMessages.trnsOutEffectiveDate; track validation) {
            <span>
              @if (form1.get('trnsOutEffectiveDate').hasError(validation.type) && (form1.get('trnsOutEffectiveDate').dirty || form1.get('trnsOutEffectiveDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown class="w-100" [options]="trnsReasons" formControlName="trnsOutReason" optionLabel="name"
          optionValue="value" placeholder="Trns In Reason" [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
          <label for="trnsOutReason">Trns Out Reason</label>
          @for (validation of validationMessages.trnsOutReason; track validation) {
            <span>
              @if (form1.get('trnsOutReason').hasError(validation.type) && (form1.get('trnsOutReason').dirty || form1.get('trnsOutReason').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="trnsOutNewMgrName" id="trnsOutNewMgrName" type="text" pInputText>
          <label for="trnsOutNewMgrName">Trns Out New Mgr Name</label>
          @for (validation of validationMessages.trnsOutNewMgrName; track validation) {
            <span>
              @if (form1.get('trnsOutNewMgrName').hasError(validation.type) && (form1.get('trnsOutNewMgrName').dirty || form1.get('trnsOutNewMgrName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="trnsOutReasonDesc" id="trnsOutReasonDesc" [rows]="2"
          pInputTextarea></textarea>
          <label for="trnsOutReasonDesc">Trns Out Reason Description</label>
          @for (validation of validationMessages.trnsOutReasonDesc; track validation) {
            <span>
              @if (form1.get('trnsOutReasonDesc').hasError(validation.type) && (form1.get('trnsOutReasonDesc').dirty || form1.get('trnsOutReasonDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="trnsOutProcessDesc" id="trnsOutProcessDesc" [rows]="2"
          pInputTextarea></textarea>
          <label for="trnsOutProcessDesc">Trns Out Process Description</label>
          @for (validation of validationMessages.trnsOutProcessDesc; track validation) {
            <span>
              @if (form1.get('trnsOutProcessDesc').hasError(validation.type) && (form1.get('trnsOutProcessDesc').dirty || form1.get('trnsOutProcessDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="trnsOutHonoredBookingsDesc" id="trnsOutHonoredBookingsDesc" [rows]="2"
          pInputTextarea></textarea>
          <label for="trnsOutHonoredBookingsDesc">Trns Out Honored Bookings Desc</label>
          @for (validation of validationMessages.trnsOutHonoredBookingsDesc; track validation) {
            <span>
              @if (form1.get('trnsOutHonoredBookingsDesc').hasError(validation.type) && (form1.get('trnsOutHonoredBookingsDesc').dirty || form1.get('trnsOutHonoredBookingsDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
  </div>

  <div>
    <div class="fw-bold mb-2 title">Contract Terms</div>
    <div class="row contract-modifications">
      <div class="col-md-4">
        <span class="p-float-label mb-3">
          <input [style]="{'width':'100%'}" formControlName="initialTermLengthMonths" id="initialTermLengthMonths"
            type="number" pInputText>
          <label for="initialTermLengthMonths">Init. Term (mo.)</label>
          @for (validation of validationMessages.initialTermLengthMonths; track validation) {
            <span>
              @if (form1.get('initialTermLengthMonths').hasError(validation.type) && (form1.get('initialTermLengthMonths').dirty || form1.get('initialTermLengthMonths').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-md-4">
        <span class="p-float-label mb-3">
          <input [style]="{'width':'100%'}" formControlName="subsequentTermLengthMonths"
            id="subsequentTermLengthMonths" type="number" pInputText>
          <label for="subsequentTermLengthMonths">Subseq. Term (mo.)</label>
          @for (validation of validationMessages.subsequentTermLengthMonths; track validation) {
            <span>
              @if (form1.get('subsequentTermLengthMonths').hasError(validation.type) && (form1.get('subsequentTermLengthMonths').dirty || form1.get('subsequentTermLengthMonths').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label required-field mb-3">
          <p-dropdown [style]="{'width':'100%'}" [options]="percentages" formControlName="mgmtCommPct"
            optionLabel="name" optionValue="value" placeholder="Management Fee %"
          [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
          <label for="mgmtCommPct">Mgmt Fee %</label>
          @for (validation of validationMessages.mgmtCommPct; track validation) {
            <span>
              @if (form1.get('mgmtCommPct').hasError(validation.type) && (form1.get('mgmtCommPct').dirty || form1.get('mgmtCommPct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">

      <div class="col-md-4">
        <span class="p-float-label required-field mb-3">
          <p-inputNumber [style]="{'width':'100%'}" formControlName="estGrossRev" [minFractionDigits]="2"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="estGrossRev">Estimated Gross Revenue $</label>
          @for (validation of validationMessages.estGrossRev; track validation) {
            <span>
              @if (form1.get('estGrossRev').hasError(validation.type) && (form1.get('estGrossRev').dirty || form1.get('estGrossRev').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-md-4">
        <span class="p-float-label required-field mb-3">
          <p-inputNumber [style]="{'width':'100%'}" formControlName="referralFeeAMT" [minFractionDigits]="2"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="referralFeeAMT">Realtor Referral Fee $</label>
          @for (validation of validationMessages.referralFeeAMT; track validation) {
            <span>
              @if (form1.get('referralFeeAMT').hasError(validation.type) && (form1.get('referralFeeAMT').dirty || form1.get('referralFeeAMT').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label mb-3">
          <input [style]="{'width':'100%'}" formControlName="freeDepartureCleanNUM" id="freeDepartureCleanNUM"
            type="number" pInputText>
          <label for="freeDepartureCleanNUM">Free Dep. Cleans #</label>
          @for (validation of validationMessages.freeDepartureCleanNUM; track validation) {
            <span>
              @if (form1.get('freeDepartureCleanNUM').hasError(validation.type) && (form1.get('freeDepartureCleanNUM').dirty || form1.get('freeDepartureCleanNUM').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


    </div>

    <div class="row">


      <div class="col-md-4">
        <span class="p-float-label required-field mb-3">
          <p-inputNumber [style]="{'width':'100%'}" formControlName="otherCreditAMT" [minFractionDigits]="2"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="otherCreditAMT">Other Fees $</label>
          @for (validation of validationMessages.otherCreditAMT; track validation) {
            <span>
              @if (form1.get('otherCreditAMT').hasError(validation.type) && (form1.get('otherCreditAMT').dirty || form1.get('otherCreditAMT').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label required-field mb-3">
          <p-inputNumber [style]="{'width':'100%'}" formControlName="maxMaintenanceFeeDiscretionAMT"
            [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="maxMaintenanceFeeDiscretionAMT">Owner Approval Threshold $</label>
          @for (validation of validationMessages.maxMaintenanceFeeDiscretionAMT; track validation) {
            <span>
              @if (form1.get('maxMaintenanceFeeDiscretionAMT').hasError(validation.type) && (form1.get('maxMaintenanceFeeDiscretionAMT').dirty || form1.get('maxMaintenanceFeeDiscretionAMT').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label mb-3">
          <input [style]="{'width':'100%'}" formControlName="freeCarDaysNUM" id="freeCarDaysNUM" type="number"
            pInputText>
          <label for="freeCarDaysNUM">Free Car Days #</label>
          @for (validation of validationMessages.freeCarDaysNUM; track validation) {
            <span>
              @if (form1.get('freeCarDaysNUM').hasError(validation.type) && (form1.get('freeCarDaysNUM').dirty || form1.get('freeCarDaysNUM').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>


    <div class="row">
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <p-inputNumber formControlName="purchasePriceAMT" id="purchasePriceAMT" inputId="currency-us"
            mode="currency" currency="USD" locale="en-US" [style]="{'width':'100%'}">
          </p-inputNumber>
          <label for="purchasePriceAMT">Purchase Price AMT</label>
          @for (validation of validationMessages.purchasePriceAMT; track validation) {
            <span>
              @if (form1.get('purchasePriceAMT').hasError(validation.type) && (form1.get('purchasePriceAMT').dirty || form1.get('purchasePriceAMT').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="purchaseDate" inputId="purchaseDate" appendTo="body">
          </p-calendar>
          <label for="purchaseDate">Purchase Date</label>
          @for (validation of validationMessages.purchaseDate; track validation) {
            <span>
              @if (form1.get('purchaseDate').hasError(validation.type) && (form1.get('purchaseDate').dirty || form1.get('purchaseDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="contractSignDate" inputId="contractSignDate" appendTo="body">
          </p-calendar>
          <label for="contractSignDate">Contract Sign Date</label>
          @for (validation of validationMessages.contractSignDate; track validation) {
            <span>
              @if (form1.get('contractSignDate').hasError(validation.type) && (form1.get('contractSignDate').dirty || form1.get('contractSignDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

    </div>

    <div class="row">
      <div class="col-md-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="firstCheckInDate" inputId="firstCheckInDate" appendTo="body">
          </p-calendar>
          <label for="firstCheckInDate">First CheckIn Date</label>
          @for (validation of validationMessages.firstCheckInDate; track validation) {
            <span>
              @if (form1.get('firstCheckInDate').hasError(validation.type) && (form1.get('firstCheckInDate').dirty || form1.get('firstCheckInDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-md-4">
        <span class="p-float-label required-field mb-3">
          <p-inputNumber [style]="{'width':'100%'}" formControlName="mgmtFeeCreditAMT" [minFractionDigits]="2"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="mgmtFeeCreditAMT">Temp. Fee Waiver $</label>
          @for (validation of validationMessages.mgmtFeeCreditAMT; track validation) {
            <span>
              @if (form1.get('mgmtFeeCreditAMT').hasError(validation.type) && (form1.get('mgmtFeeCreditAMT').dirty || form1.get('mgmtFeeCreditAMT').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="contract-modifications-right p-float-label">
          <textarea [style]="{'width':'100%'}" formControlName="termsSummaryDesc" id="termsSummaryDesc"
          pInputTextarea></textarea>
          <label for="contractNote">Terms Summary Description</label>
          @for (validation of validationMessages.termsSummaryDesc; track validation) {
            <span>
              @if (form1.get('termsSummaryDesc').hasError(validation.type) && (form1.get('termsSummaryDesc').dirty || form1.get('termsSummaryDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="fw-bold my-3 title">Onboarding Credits</div>
    <div class="row contract-modifications">
      <div class="col-md-4">
        <span class="p-float-label required-field mb-3">
          <p-inputNumber [style]="{'width':'100%'}" formControlName="upgradeCredit" [minFractionDigits]="2"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="upgradeCredit">Upgrade Credit $</label>
          @for (validation of validationMessages.upgradeCredit; track validation) {
            <span>
              @if (form1.get('upgradeCredit').hasError(validation.type) && (form1.get('upgradeCredit').dirty || form1.get('upgradeCredit').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <!-- <div class="col-md-2">
      <span class="p-float-label required-field mb-3">
        <p-inputNumber [style]="{'width':'100%'}" formControlName="signOnBonus" [minFractionDigits]="2"
          inputId="currency-us" mode="currency" currency="USD" locale="en-US">
        </p-inputNumber>
        <label for="signOnBonus">Sign On Bonus $</label>
        <span *ngFor="let validation of validationMessages.signOnBonus">
          <small class="p-invalid"
            *ngIf="form1.get('signOnBonus').hasError(validation.type) && (form1.get('signOnBonus').dirty || form1.get('signOnBonus').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div> -->

    <div class="col-md-4">
      <span class="p-float-label required-field mb-3">
        <p-inputNumber [style]="{'width':'100%'}" formControlName="signCreditAMT" [minFractionDigits]="2"
          inputId="currency-us" mode="currency" currency="USD" locale="en-US">
        </p-inputNumber>
        <label for="signCreditAMT">Sign-on Bonus (Amt/Due)</label>
        @for (validation of validationMessages.signCreditAMT; track validation) {
          <span>
            @if (form1.get('signCreditAMT').hasError(validation.type) && (form1.get('signCreditAMT').dirty || form1.get('signCreditAMT').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-md-4">
      <span class="p-float-label required-field mb-3">
        <p-inputNumber [style]="{'width':'100%'}" formControlName="remodelCreditAMT" [minFractionDigits]="2"
          inputId="currency-us" mode="currency" currency="USD" locale="en-US">
        </p-inputNumber>
        <label for="remodelCreditAMT">Furn/Other Credit (Amt/Due)</label>
        @for (validation of validationMessages.remodelCreditAMT; track validation) {
          <span>
            @if (form1.get('remodelCreditAMT').hasError(validation.type) && (form1.get('remodelCreditAMT').dirty || form1.get('remodelCreditAMT').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>
</div>

<div>
  <div class="mb-3 fw-bold title">Others</div>
  <div class="row">
    <div class="col-md-4">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown class="w-100" [options]="revenuePlanOptions" formControlName="revenuePlan"
          optionLabel="name" optionValue="value" placeholder="Revenue Plan"
        [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
        <label for="revenuePlan">Revenue Plan</label>
        @for (validation of validationMessages.revenuePlan; track validation) {
          <span>
            @if (form1.get('revenuePlan').hasError(validation.type) && (form1.get('revenuePlan').dirty || form1.get('revenuePlan').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-md-4">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown class="w-100" [options]="propertyConditionOptions" formControlName="propertyCondition"
          optionLabel="name" optionValue="value" placeholder="Property Condition"
        [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
        <label for="propertyCondition">Property Condition</label>
        @for (validation of validationMessages.propertyCondition; track validation) {
          <span>
            @if (form1.get('propertyCondition').hasError(validation.type) && (form1.get('propertyCondition').dirty || form1.get('propertyCondition').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-md-4">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="propertyScore" id="propertyScore" type="number" pInputText [readonly]="false">
        <label for="propertyScore">Property Score</label>
        @for (validation of validationMessages.propertyScore; track validation) {
          <span>
            @if (form1.get('propertyScore').hasError(validation.type) && (form1.get('propertyScore').dirty || form1.get('propertyScore').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>

  <div class="row">

    <div class="col-md-4">
      <span class="p-float-label required-field mb-3">
        <p-inputNumber [style]="{'width':'100%'}" formControlName="bookingFee" [minFractionDigits]="2"
          inputId="currency-us" mode="currency" currency="USD" locale="en-US">
        </p-inputNumber>
        <label for="bookingFee">Booking Fee $</label>
        @for (validation of validationMessages.bookingFee; track validation) {
          <span>
            @if (form1.get('bookingFee').hasError(validation.type) && (form1.get('bookingFee').dirty || form1.get('bookingFee').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-md-4">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown class="w-100" [options]="maintServiceFreqOptions" formControlName="maintServiceFreq"
          optionLabel="name" optionValue="value" placeholder="Maint Service Freq"
        [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
        <label for="maintServiceFreq">Maint Service Freq</label>
        @for (validation of validationMessages.maintServiceFreq; track validation) {
          <span>
            @if (form1.get('maintServiceFreq').hasError(validation.type) && (form1.get('maintServiceFreq').dirty || form1.get('maintServiceFreq').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-md-4"></div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="stmtProcDesc" id="stmtProcDesc" [rows]="2" pInputTextarea
        [readonly]="false"></textarea>
        <label for="stmtProcDesc">Statement processing descriptions</label>
        @for (validation of validationMessages.stmtProcDesc; track validation) {
          <span>
            @if (form1.get('stmtProcDesc').hasError(validation.type) && (form1.get('stmtProcDesc').dirty || form1.get('stmtProcDesc').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="propertyScoreDesc" id="propertyScoreDesc" [rows]="2" pInputTextarea
        [readonly]="false"></textarea>
        <label for="propertyScoreDesc">Property Score Description</label>
        @for (validation of validationMessages.propertyScoreDesc; track validation) {
          <span>
            @if (form1.get('propertyScoreDesc').hasError(validation.type) && (form1.get('propertyScoreDesc').dirty || form1.get('propertyScoreDesc').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>
</div>

</div>
<div class="col-md-6">
  <app-notes-chat [config]="notesChatConfig" [noteSourceId]="propertyProfileId" [noteSource]="60"></app-notes-chat>
</div>

</div>
</div>



</div>




@if (propertyProfileId) {
  <hr>
  }
  @if (propertyProfileId) {
    <div class="col-md-6">
      <app-tag-join-select [tagSource]="60" [tagSourceId]="propertyProfileId" tagType="4">
      </app-tag-join-select>
    </div>
  }

  <!-- <hr *ngIf="propertyProfileId">
  <div class="col-md-12" *ngIf="propertyProfileId">
    <app-note-list [noteSource]="60" [noteSourceId]="propertyProfileId"
    (messageEvent)="setAssignedToUserId($event)"></app-note-list>
  </div> -->

  <hr>
    <div class="row m-0">
      <div class="col-md-12">
        <div class="btn-group">
          <div class="button-group">
            @if (propertyProfileId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete PropertyProfile</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" (click)="closePopUpOfQuote()">Cancel</button>
            @if (!propertyProfileId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add
              PropertyProfile</button>
            }

            @if (propertyProfileId) {
              <button pButton class="btn-upt p-button" (click)="formUpdate()">Update
              PropertyProfile</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>